import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { Table } from "../../../../components/ui";
import usePagination from "../../../../hooks/usePagination";
import { appendSearchParamsToQuery } from "../../../ComplianceSearch/utils";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { HELIOS_LIVE_SIM_TIF_COLUMNS } from "../../../ComplianceSearch/constants";
import { fundedComplianceProfileActions } from "../../../../reducers/fundedComplianceProfile";

const LiveSimTif: React.FC = () => {
  const dispatch = useDispatch();
  const pagination = usePagination();
  const params: { id: string } = useParams();

  const { data, isLoading } = useSelector((state) => state.fundedComplianceProfile.liveSimTif);

  const search = { compliance_entries_id: params.id };
  const { isError, error } = useQuery({
    retry: false,
    queryKey: [COMPLIANCE_API_URLS.getLiveSimTif, pagination.page, pagination.limit, search],
    async queryFn({ signal }) {
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());
      appendSearchParamsToQuery(search, query);

      dispatch(fundedComplianceProfileActions.fetchLiveSimTifRequest());

      const { data } = await ComplianceAPI.getWatchlistLiveSimTif(query.toString(), signal);
      pagination.setCount(data.results.count);

      dispatch(fundedComplianceProfileActions.fetchLiveSimTifSuccess(data.results));

      return data;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(fundedComplianceProfileActions.fetchLiveSimTifFailed());
      console.error("Error fetching LiveSIM Trader Information Form", error);
    }
  }, [isError, error]);

  useEffect(() => {
    pagination.setPage(0);
  }, [search, pagination.limit]);

  return (
    <div>
      <Table
        loading={isLoading}
        pagination={pagination}
        columns={HELIOS_LIVE_SIM_TIF_COLUMNS}
        extractKey={(row) => row.id}
        data={data.rows}
        theadTitle="LiveSIM TIF"
        csv_table_name={`LiveSIM TIF entry ID: ${params.id}`}
      />
    </div>
  );
};

export default LiveSimTif;
